module.exports = __webpack_public_path__ + "static/media/tournament-bg.31399f50.svg";